import { OrganizationEventsForBookingData } from "../../models/organizationEventsForBookingData";

/**
 * @interface OrganizationEventsForBookingState
 */
export interface OrganizationEventsForBookingState {
  events: OrganizationEventsForBookingData[];
  isLoading: boolean;
  organizationEventsForBookingLoaded: boolean;
  error: string | null;
}

export const FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_REQUEST =
  "FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_REQUEST";
export const FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_SUCCESS =
  "FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_SUCCESS";
export const FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_FAILURE =
  "FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_FAILURE";

export interface FetchOrganizationEventsForBookingRequestAction {
  type: typeof FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_REQUEST;
}

export interface FetchOrganizationEventsForBookingSuccessAction {
  type: typeof FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_SUCCESS;
  events: OrganizationEventsForBookingData[];
}
export interface FetchOrganizationEventsForBookingFailureAction {
  type: typeof FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_FAILURE;
  error: string;
}

export type OrganizationEventsForBookingActionTypes =
  | FetchOrganizationEventsForBookingRequestAction
  | FetchOrganizationEventsForBookingSuccessAction
  | FetchOrganizationEventsForBookingFailureAction;
